import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Body1 from '../Typography/Body/Body1';
import Headline2 from '../Typography/Heading/Headline2';
import rose from '../Palettes/rose';
import colors from '../Theme/colors';

interface HeroContentProperties {
  eyebrow: ReactNode;
  headline: ReactNode;
  description: ReactNode;
  cta?: ReactNode;
  className?: string;
}

const Container = styled.div`
  color: ${colors.white};

  .MuiTypography-root {
    color: inherit;
  }
`;

const Eyebrow = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: ${rose[600]};
  margin-bottom: 1.5rem;
`;

const Description = styled(Body1)`
  margin: 1.5rem 0 2rem;
  max-width: 36rem;
  opacity: 0.85;
`;

const CtaWrapper = styled.div`
  align-self: flex-start;
`;

export const HeroHighlight = styled.span`
  color: ${rose[600]};
`;

const HeroContent = ({
  eyebrow,
  headline,
  description,
  cta,
  className,
}: HeroContentProperties) => (
  <Container className={className}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <Headline2 tag="h1">{headline}</Headline2>
    <Description>{description}</Description>
    {cta && <CtaWrapper>{cta}</CtaWrapper>}
  </Container>
);

export default HeroContent;
